<template>
  <div class="default-toggle" :class="[size]">
    <label class="toggle" :class="{ disabled: disabled }">
      <input
        type="checkbox"
        @change="updateValue($event.target.checked)"
        :checked="value"
        :disabled="disabled"
      />
      <span class="slider"></span>
    </label>
  </div>
</template>

<script>
export default {
  name: 'TjingToggle',
  props: ['value', 'disabled', 'size'],
  data() {
    return {}
  },
  computed: {},
  methods: {
    updateValue: function (value) {
      this.$emit('input', value)
    },
  },
  mounted() {},
  beforeCreate() {},
  destroyed() {},
}
</script>

<style lang="scss" scoped>
.default-toggle {
  user-select: none;
}
.disabled {
  input:checked + .slider {
    background-color: $sleet;
    border: 2px solid $sleet;
    cursor: default;
    &:before {
      background-color: white;
    }
    &:hover {
      border: 2px solid $sleet;
    }
  }
  input + .slider {
    border: 2px solid $sleet;
    cursor: default;

    &:before {
      background: $sleet;
    }
  }
}

.toggle {
  position: relative;
  display: inline-block;
  width: 38px;
  height: 24px;
}

/* Hide default HTML checkbox */
.toggle input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  -webkit-transition: 0.4s;
  transition: 0.3s all ease-in;
  border: 2px solid $strom;

  &:hover {
    border: 2px solid $midnight;

    &:before {
      background-color: $midnight;
    }
  }
}

.slider:before {
  position: absolute;
  content: '';
  height: 16px;
  width: 16px;
  left: 2px;
  bottom: 2px;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  background-color: $strom;
}

input:checked + .slider {
  background-color: $twilight;
  border: 2px solid $twilight;
}

input:focus + .slider {
  box-shadow: none;
}

input:checked + .slider:before {
  transform: translateX(14px);
}

/* Rounded sliders */
.slider {
  border-radius: 32px;
}

.slider:before {
  border-radius: 50%;
}

@media (min-width: 480px) and (orientation: landscape) {
}

@media (min-width: 544px) {
}

@media (min-width: 768px) {
}

@media (min-width: 1200px) {
  .large {
    .toggle {
      width: 72px;
      height: 44px;
    }
    .slider:before {
      height: 32px;
      width: 32px;
      left: 4px;
      bottom: 5px;
    }
    input:checked + .slider:before {
      -webkit-transform: translateX(30px);
      -ms-transform: translateX(30px);
      transform: translateX(30px);
    }
  }
}
</style>
